// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__14am5","summary":"CartItem_summary__1tOSg","price":"CartItem_price__1rK_f","amount":"CartItem_amount__2-WLD","actions":"CartItem_actions__3POBO"};